<template>
    <div class="line-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/core";
import { ToolboxComponent, TooltipComponent, GridComponent, LegendComponent } from "echarts/components";
import { BarChart, LineChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
    ToolboxComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    LineChart,
    CanvasRenderer,
    UniversalTransition,
]);

console.log("echarts", echarts);
Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=data-transform-filter
export default Vue.extend({
    name: "LineChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart",
        },
        yAxis: {
            type: Array,
            default: () => [],
        },
        legend: {
            type: Array,
            default: () => [],
        },
        xAxisData: {
            type: Array,
            default: () => [],
        },
        series: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getOptions() {
            return {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                toolbox: {
                    feature: {
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ["line", "bar"] },
                        restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                legend: {
                    data: ["TotalPriceData", "TotalPaidPriceData", "TotalUnPaidPriceData"],
                },
                xAxis: [
                    {
                        type: "category",
                        data: this.xAxisData,
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: this.yAxis,
                series: this.series,
            };
        },
    },
});
</script>

<style scoped lang="scss">
.line-chart {
    width: 100%;
    height: 300px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
